module.exports = __webpack_public_path__ + "media/bootstrap-icons/Boxes-142a5101.svg";